module.exports = __webpack_public_path__ + "img/consolidated-apps-urls.f902ce56.png";